import React, { useRef, useState } from 'react';

import { API } from 'constants';
import client from '../../../../services/library-api';

import { useOverlayState } from '../../../../hooks/useOverlayState';

import { defaultErrorMessage } from '../../../../constants/errorMessages';

import ErrorAlert from '../../../../design-system/ErrorAlert/ErrorAlert';
import EditLineIcon from '../../../../design-system/Icons/EditLineIcon';
import ConfirmDeleteWebhookNotificationModal from '../ConfirmDeleteWebhookNotificationModal/ConfirmDeleteWebhookNotificationModal';
import { ButtonIcon, Toggle } from '../../../../design-system';
import { DeleteBin4LineIcon } from '../../../../design-system/Icons';

const WebhookNotificationCard = ({
    agentId,
    notification,
    setSuccessAlert,
    setNotificationModal,
    setWebhookNotifications,
    updateNotificationInState,
}) => {
    const { id, name, is_live, detail, event_listener, delivery } = notification;
    const { isOpened: isDeleteModalOpened, toggle: toggleDeleteModal } = useOverlayState();

    const [errorAlert, setErrorAlert] = useState(null);

    const controller = useRef(new AbortController());
    const stableIsLive = useRef(is_live);

    const toggleIsLive = async (is_live) => {
        try {
            controller.current?.abort();
            controller.current = new AbortController();

            const requestBody = {
                name,
                event_listener,
                delivery,
                is_live,
                detail: {
                    webhook_url: detail.webhook_url,
                },
            };
            updateNotificationInState({ id, ...requestBody });
            const { data } = await client.patch(
                API.ROUTES.library.process + agentId + '/event/' + id + '/',
                requestBody,
                { signal: controller.current.signal }
            );
            stableIsLive.current = data.is_live;
            if (is_live !== data.is_live) {
                updateNotificationInState({ id, is_live: data.is_live });
            }
        } catch (error) {
            if (error.message === 'canceled') {
                return;
            }
            updateNotificationInState({ id, is_live: stableIsLive.current });
            setErrorAlert({ message: defaultErrorMessage, statusCode: error.response?.status });
        }
    };

    const openEditModal = () => setNotificationModal({ mode: 'edit', data: notification });

    return (
        <div className="flex items-center gap-3 border-b-1 border-neutral-200 overflow-hidden">
            <Toggle isSelected={is_live} name="is_live" onChange={toggleIsLive} size="sm" />
            <p className="font-body-bold text-body-bold-s text-neutral-500 flex-grow truncate">
                {name}
            </p>
            <div className="flex items-center gap-0">
                <ButtonIcon type="link" size="xs" icon={EditLineIcon} onClick={openEditModal} />
                <ButtonIcon
                    type="link"
                    size="xs"
                    icon={DeleteBin4LineIcon}
                    onClick={toggleDeleteModal}
                />
            </div>

            {isDeleteModalOpened && (
                <ConfirmDeleteWebhookNotificationModal
                    agentId={agentId}
                    notification={notification}
                    setWebhookNotifications={setWebhookNotifications}
                    setSuccessAlert={setSuccessAlert}
                    onClose={toggleDeleteModal}
                />
            )}

            <ErrorAlert errorAlert={errorAlert} setErrorAlert={setErrorAlert} />
        </div>
    );
};

export default WebhookNotificationCard;
